import React from "react";
import { Box, Divider } from "@mui/joy";
import type { PeriodStats } from "../../../api/stats/Stats.typed";
import DarkCard from "../../common/DarkCard";
import DarkTypography from "../../common/DarkTypography";
import { darkDividerBorder, statsStatRowSx } from "../../../styles/globalStyles";
import type { StatsMetricGroup } from "../statsPeriodHelpers";
import StatsMetricValue from "./StatsMetricValue";

type StatsMetricCardProps = {
  group: StatsMetricGroup;
  stats: PeriodStats;
};

export default function StatsMetricCard({ group, stats }: StatsMetricCardProps) {
  return (
    <DarkCard sx={{ minWidth: 0 }}>
      <DarkTypography level="title-md" colorVariant="title" sx={{ mb: 1.5 }}>
        {group.title}
      </DarkTypography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        {group.metrics.map((metric, index) => (
          <React.Fragment key={metric.label}>
            {index > 0 && <Divider sx={{ borderColor: darkDividerBorder, my: 0.5 }} />}
            <Box sx={{ ...statsStatRowSx, gap: 1, minHeight: 32 }}>
              <DarkTypography level="body-sm" colorVariant="primary" sx={{ minWidth: 0 }}>
                {metric.label}
              </DarkTypography>
              <StatsMetricValue tone={metric.tone} value={metric.value(stats)} />
            </Box>
          </React.Fragment>
        ))}
      </Box>
    </DarkCard>
  );
}
